import { DATE_TIME_FORMAT } from '@/constants'
import moment from 'moment-timezone'
import { getCurrentInstance } from 'vue'
import type { RootProps } from '@/types'

export const getLocalTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const getServerTimezone = (): string => {
  return import.meta.env.VITE_SERVER_TIMEZONE || 'America/New_York'
}

export const convertTimezone = (
  inputDateTime: string,
  inputTimezone: string,
  outputTimezone: string,
): string => {
  return moment
    .tz(inputDateTime, inputTimezone)
    .tz(outputTimezone)
    .format(DATE_TIME_FORMAT)
}

export const convertLocalTimeToServerTime = (localTime: string): string => {
  return convertTimezone(localTime, getLocalTimezone(), getServerTimezone())
}

export const convertServerTimeToLocalTime = (serverTime: string): string => {
  return convertTimezone(serverTime, getServerTimezone(), getLocalTimezone())
}

export const getDataCouponId = () =>
  document
    .getElementsByClassName('coupon-builder-cx')[0]
    ?.getAttribute('data-coupon-id') ?? null

export function getAccountId(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search)
  const accountIdFromUrl = urlParams.get('account_id')

  if (accountIdFromUrl && accountIdFromUrl !== '') {
    return accountIdFromUrl
  }

  // Check DOM attributes
  const app = getCurrentInstance()
  const rootProps = app?.proxy?.$root?.$attrs as RootProps | undefined
  const accountIdFromElement = rootProps?.accountId ?? ''

  if (accountIdFromElement && accountIdFromElement !== '') {
    return accountIdFromElement
  }

  return ''
}

export function getPlacementId(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search)
  const placementIdFromUrl = urlParams.get('placement_id')

  if (placementIdFromUrl && placementIdFromUrl !== '') {
    return placementIdFromUrl
  }

  // Check DOM attributes
  const app = getCurrentInstance()
  const rootProps = app?.proxy?.$root?.$attrs as RootProps | undefined
  const placementIdFromElement = rootProps?.placementId ?? ''

  if (placementIdFromElement && placementIdFromElement !== '') {
    return placementIdFromElement
  }

  return ''
}

export function getCouponId(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search)
  const couponIdFromUrl = urlParams.get('coupon_id')

  if (couponIdFromUrl && couponIdFromUrl !== '') {
    return couponIdFromUrl
  }

  // Check DOM attributes
  const app = getCurrentInstance()
  const rootProps = app?.proxy?.$root?.$attrs as RootProps | undefined
  const couponIdFromElement = rootProps?.couponId ?? ''

  if (couponIdFromElement && couponIdFromElement !== '') {
    return couponIdFromElement
  }

  return ''
}
